/**
 * This is currently using on Single and Multiple Answer;
 */
const SingleAnswer = ({ ...props }) => {

    const answerChoices = props.answerChoices ?? []// []
    const userAnswer = props.userAnswer.answer_data ? JSON.parse(props.userAnswer.answer_data ) : []
    const refId = userAnswer.statistic_ref_id ?? "single_answer_" + Math.random().toString(16).slice(2)
    const pointScored = Number( props.info.quizPointsScored ?? "0" )
    const selectedAnswerIndex = userAnswer.findIndex((num) => num)

    return (
        <div className='msync-question-container__answer__single'>
            { answerChoices.map(( choice, index ) => {
                const isSelected = userAnswer[index]

                let colorClass = ""

                if( pointScored && selectedAnswerIndex === index || choice._correct ){
                    colorClass = "msync_ld_correct"
                }

                if( !pointScored && !choice._correct ){
                    colorClass = "msync_ld_incorrect"
                }

                return (
                    <div className={`msync-question-container__answer__single__choices ${colorClass}`} key={index}>
                        <input type="radio" value={ choice._answer ?? "" } radioGroup={refId} id={refId} checked={isSelected} disabled />
                        <label htmlFor={refId}>{ choice._answer ?? ""}</label>
                    </div> )
            })}
        </div>
    )
}

export default SingleAnswer